<template lang='pug' src='./app.pug'></template>

<script>
// components
import Navigation from 'components/navigation/navigation'
import Home from '@/pages/home/home'
import HomeMobile from '@/pages/home/home-mobile/home-mobile'
import BaseBaseAccess from 'components/base-access/index'
import Accessibility from '@/pages/accessibility/accessibility'

export default {
  async created () {
    this.$store.dispatch('GET_PAGES')
    this.$store.dispatch('GET_APP')
    this.$store.dispatch('SCROLL', false)
    this.$store.dispatch('VIEW_BODY', false)
    this.$store.dispatch('VIEW_TYPES', 0)
    this.$store.dispatch('SHOW_MODAL', false)
    this.$store.dispatch('VIEW_MODALCONTENT', false)
    this.$store.dispatch('VIEW_DRAWER', false)
    this.$store.dispatch('LOADING', true)
    this.$store.dispatch('VIEW_COLOR', false)
    this.$store.dispatch('VIEW_OFFICE', false)
  },
  components: {
    Home,
    HomeMobile,
    Navigation,
    BaseBaseAccess,
    Accessibility
  },
  name: 'app'
}
</script>

<-- styles have been moved to main.sass file -->
<style src='../main.sass' lang='sass'></style>



// WEBPACK FOOTER //
// app.vue?c30c0fb0